import { Timestamp } from 'firebase/firestore';
import type { Expense, Profile } from '@/lib/types';

function toIsoString(value: unknown): string {
  if (!value) return new Date().toISOString();
  if (typeof value === 'string') return value;
  if (value instanceof Date) return value.toISOString();
  if (typeof value === 'object' && value && 'toDate' in value && typeof value.toDate === 'function') {
    return value.toDate().toISOString();
  }
  return new Date().toISOString();
}

function toNumber(value: unknown): number {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
}

export function mapExpenseDoc(id: string, data: Record<string, unknown>): Expense {
  return {
    id,
    created_at: toIsoString(data.created_at),
    user_id: String(data.user_id || ''),
    transaction_date: toIsoString(data.transaction_date),
    store_name: (data.store_name as string | null | undefined) ?? null,
    items: Array.isArray(data.items) ? (data.items as Expense['items']) : [],
    subtotal: toNumber(data.subtotal),
    tax: toNumber(data.tax),
    discount: toNumber(data.discount),
    total: toNumber(data.total),
    status: (data.status as Expense['status']) || 'pending',
    notes: (data.notes as string | null | undefined) ?? null,
    receipt_url: (data.receipt_url as string | null | undefined) ?? null,
    last_updated_at: data.last_updated_at ? toIsoString(data.last_updated_at) : undefined,
    updated_by: (data.updated_by as string | undefined) ?? undefined,
  };
}

export function mapProfileDoc(id: string, data: Record<string, unknown>): Profile {
  return {
    id,
    display_name: (data.display_name as string | null | undefined) ?? null,
    email: (data.email as string | null | undefined) ?? null,
    role: (data.role as string | undefined) || 'user',
    created_at: toIsoString(data.created_at),
  };
}

export function toTimestamp(value: string) {
  return Timestamp.fromDate(new Date(value));
}
